import { ProjectLandingLayout } from "./layout";
import NewProject from "./NewProject";
import { Projects } from "./Projects";

export const ProjectLanding = () => {
  return (
    <ProjectLandingLayout>
      <NewProject />
      <Projects />
    </ProjectLandingLayout>
  );
};
